import React from 'react';
import { overridable } from '@24i/nxg-sdk-gluons/src/context/ComponentOverrides';
import { withWebHeader } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader';
import AppGrid from '../../../components/AppGrid';
import { MyRecentlyWatchedViewProps } from '../types';

const RecentlyWatchedScreen = (props: MyRecentlyWatchedViewProps) => <AppGrid {...props} />;

export default withWebHeader(overridable(RecentlyWatchedScreen, 'RecentlyWatchedScreen'));
